import {Injectable} from '@angular/core';
import {LanguageService} from '@spartacus/core';
import {DcpCurrencyService} from '../pricing/dcp-currency.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class CommonPropertiesService {

  currentCurrency: string;
  currentLanguage: string;

  constructor(
    private currencyService: DcpCurrencyService,
    private languageService: LanguageService,
  ) {
    this.currencyService.getActive().pipe(untilDestroyed(this)).subscribe(currency => {
      this.currentCurrency = currency;
    });
    this.languageService.getActive().pipe(untilDestroyed(this)).subscribe(language => {
      this.currentLanguage = language;
    });
  }

  public fillCurrency(data: any) {
    if (!data) {
      return;
    }
    if (!data.ecommerce) {
      data.ecommerce = {};
    }
    data.ecommerce.currency = this.currentCurrency;
  }

  public fillLanguage(data: any) {
    if (!data) {
      return;
    }
    if (!data.page) {
      data.page = {};
    }
    data.page.language = this.currentLanguage;
  }
}
